'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const REALITY_CHECK_DISABLED_VALUE = 16666.65;

exports.REALITY_CHECK_DISABLED_VALUE = REALITY_CHECK_DISABLED_VALUE;
